import { render } from "./UserPage_home.vue?vue&type=template&id=6acea0d6&scoped=true"
import script from "./UserPage_home.vue?vue&type=script&lang=js"
export * from "./UserPage_home.vue?vue&type=script&lang=js"

import "./UserPage_home.vue?vue&type=style&index=0&id=6acea0d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6acea0d6"]])

export default __exports__